import React from "react";
import "./FAQ.scss";
import {Link} from "react-router-dom";

const FAQ = () => {
  return (
    <div>
      <div className="FAQ-main">
        <div className="FAQ-outer">
          <div className="FAQ-inner">
            <div className="FAQ-part">
              <div className="part-inner row">
                <div className="head col-md-3">
                  <p>SHIPPING</p>
                </div>
                <div className="que col-md-9">
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>How does the shipping process work?</p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        We make an effort to quickly process and ship orders.
                        Our website allows you to track your order, and we offer
                        frequent updates on the status of your shipment. Visit
                        the website to review our shipping policy for further
                        specific details.
                      </p>
                    </div>
                  </div>
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>Do You Ship Internationally?</p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>No, We ship only in India</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="part-inner row">
                <div className="head col-md-3">
                  <p>Updates and Promotions</p>
                </div>
                <div className="que col-md-9">
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>
                        How can customers stay updated on new arrivals and
                        promotions?
                      </p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        Follow us on social media and subscribe to our
                        newsletter for the latest updates and exclusive
                        promotions.
                      </p>
                    </div>
                  </div>
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>Do you offer wallet payment on website?</p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        Yes, we have wallet payments for convenient ordering.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="part-inner row">
                <div className="head col-md-3">
                  <p>PAYMENT</p>
                </div>
                <div className="que col-md-9">
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>What online payment methods do you accept?</p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        We accept a variety of online payment methods for your
                        convenience. You can find the list of accepted payment
                        options during the checkout process.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="part-inner row">
                <div className="head col-md-3">
                  <p>Quality and Material</p>
                </div>
                <div className="que col-md-9">
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>
                        What sets Raer apart from other men's clothing brands?
                      </p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        We use 100% cotton for comfortable, breathable, and
                        durable clothing.
                      </p>
                    </div>
                  </div>
                  <div className="part row">
                    <div className="subpart col-md-5">
                      <p>Why is 100% cotton beneficial for clothing?</p>
                    </div>
                    <div className="subpart-body col-md-7">
                      <p>
                        It's soft, suitable for sensitive skin, and provides a
                        cool feel.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
            <div className="bottom-part">
              <div className="outer">
                <h2>
                  We’re Here to Help ! <Link to="/contact">Contact us</Link>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
